var React = require('react');

function BackToBuilder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 0H6C2.68629 0 0 2.68629 0 6V14H2V6C2 3.79086 3.79086 2 6 2H15V0ZM55 2V0H65C68.3137 0 71 2.68629 71 6V14H69V6C69 3.79086 67.2091 2 65 2H55ZM55 69H65C67.2091 69 69 67.2091 69 65V54H71V65C71 68.3137 68.3137 71 65 71H55V69ZM2 54V65C2 67.2091 3.79086 69 6 69H15V71H6C2.68629 71 0 68.3137 0 65V54H2Z","fill":"#FCB34E","key":0}),React.createElement("rect",{"x":"19","y":"19","width":"33","height":"33","rx":"3","fill":"#FCB34E","key":1}),React.createElement("path",{"d":"M28.7586 37.8L24 45H47L39.069 33L32.3276 41.5L28.7586 37.8Z","fill":"white","key":2}),React.createElement("circle",{"cx":"45.5","cy":"25.5","r":"2.5","fill":"white","key":3})]);
}

BackToBuilder.defaultProps = {"width":"71","height":"71","viewBox":"0 0 71 71","fill":"none"};

module.exports = BackToBuilder;

BackToBuilder.default = BackToBuilder;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/back-to-builder.svg
// module id = 939
// module chunks = 0